<template>
  <v-dialog v-model="dialog" max-width="900" scrollable>
    <v-card class="saldos-tarjetas">
      <EncabezadoModal titulo="Saldos de tarjetas de regalo" :subtitulo="resumen ? 'Al ' + $filters.date(resumen.fecha) : ''" icono="mdi-gift-outline" @cerrar="dialog = false" />

      <v-card-text class="pt-4">
        <SkeletonLista v-if="cargando" :filas="4" :columnas="4" />
        <template v-else-if="resumen">
          <div class="saldos-tarjetas__resumen">
            <div class="saldos-tarjetas__dato saldos-tarjetas__dato--principal">
              <span>Saldo vigente (lo que se le debe a los clientes)</span>
              <strong>{{ $filters.currency(resumen.saldo_vigente, 0) }}</strong>
              <small>{{ resumen.activas.tarjetas }} {{ resumen.activas.tarjetas == 1 ? "tarjeta activa" : "tarjetas activas" }}</small>
            </div>
            <div class="saldos-tarjetas__dato">
              <span>Vence en {{ resumen.dias_por_vencer }} días</span>
              <strong>{{ $filters.currency(resumen.saldo_por_vencer, 0) }}</strong>
            </div>
            <div class="saldos-tarjetas__dato">
              <span>Vencido sin usar</span>
              <strong>{{ $filters.currency(resumen.saldo_vencido, 0) }}</strong>
            </div>
            <div class="saldos-tarjetas__dato">
              <span>Total usado</span>
              <strong>{{ $filters.currency(resumen.total_usado, 0) }}</strong>
            </div>
            <div class="saldos-tarjetas__dato">
              <span>Por activar</span>
              <strong>{{ resumen.pendientes.tarjetas }}</strong>
              <small>{{ $filters.currency(resumen.pendientes.valor, 0) }} cobrados</small>
            </div>
          </div>

          <div class="d-flex align-center mt-4 mb-1">
            <strong>Detalle por tarjeta activa</strong>
            <v-spacer></v-spacer>
            <v-switch v-model="soloConSaldo" dense hide-details inset class="mt-0 mr-3" label="Solo con saldo"></v-switch>
            <v-btn small outlined color="primary" :disabled="!filas.length" @click="exportar()"><v-icon small left>mdi-download</v-icon>Exportar CSV</v-btn>
          </div>
          <v-data-table :headers="encabezados" :items="filas" dense :items-per-page="10" class="saldos-tarjetas__tabla" no-data-text="No hay tarjetas activas con saldo.">
            <!-- eslint-disable-next-line -->
            <template v-slot:item.code="{ item }"><span class="saldos-tarjetas__codigo">{{ item.code }}</span></template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.amount="{ item }">{{ $filters.currency(item.amount, 0) }}</template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.usado="{ item }">{{ $filters.currency(item.usado, 0) }}</template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.saldo="{ item }"><strong :class="item.saldo > 0 ? 'success--text' : 'grey--text'">{{ $filters.currency(item.saldo, 0) }}</strong></template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.expiration_date="{ item }">
              <v-chip v-if="item.vencida" x-small color="error" dark>Vencida</v-chip>
              <template v-else>{{ item.expiration_date ? $filters.date(item.expiration_date) : "Sin vencimiento" }}</template>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
/** Saldos de las tarjetas de regalo: cuánto hay sin gastar, cuánto vence y el detalle por tarjeta (exportable). */
export default {
  name: "SaldosTarjetas",
  data: () => ({
    dialog: false,
    cargando: false,
    resumen: null,
    items: [],
    soloConSaldo: true,
    encabezados: [
      { text: "Código", value: "code" },
      { text: "Valor", value: "amount", align: "end" },
      { text: "Usado", value: "usado", align: "end" },
      { text: "Saldo", value: "saldo", align: "end" },
      { text: "Vence", value: "expiration_date" },
    ],
  }),
  computed: {
    filas() {
      return this.soloConSaldo ? this.items.filter((t) => t.saldo > 0) : this.items;
    },
  },
  methods: {
    async abrir() {
      this.dialog = true;
      this.cargando = true;
      const res = await this.$http.get("api/v1/gift-card/balance-report", null, false, true);
      this.cargando = false;
      if (res && res.success) {
        this.resumen = res.resumen;
        this.items = res.items;
      } else {
        this.dialog = false;
      }
    },
    // CSV con coma, comillas y BOM para que Excel lo abra con tildes.
    exportar() {
      const celda = (v) => '"' + String(v === null || v === undefined ? "" : v).replace(/"/g, '""') + '"';
      const lineas = [["Código", "Valor", "Usado", "Saldo", "Vence", "Activada", "Último movimiento"].map(celda).join(",")];
      this.filas.forEach((t) => {
        lineas.push([t.code, t.amount, t.usado, t.saldo, t.expiration_date || "Sin vencimiento", t.activation_date, t.ultimo_movimiento].map(celda).join(","));
      });
      const blob = new Blob(["﻿" + lineas.join("\r\n")], { type: "text/csv;charset=utf-8" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = "saldos-tarjetas-" + this.resumen.fecha + ".csv";
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    },
  },
};
</script>

<style scoped>
.saldos-tarjetas__resumen {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
}
.saldos-tarjetas__dato {
  display: flex;
  flex-direction: column;
  padding: 10px 14px;
  border-radius: 8px;
  background: #f5f6f8;
}
.saldos-tarjetas__dato--principal {
  grid-column: span 2;
  background: #eaf7ee;
  border: 1px solid #b7dfb9;
}
.saldos-tarjetas__dato span {
  font-size: 12px;
  color: #5f6368;
}
.saldos-tarjetas__dato strong {
  font-size: 20px;
  color: var(--pos-azul-marino, #0b1f33);
}
.saldos-tarjetas__dato--principal strong {
  font-size: 26px;
  color: #2e7d32;
}
.saldos-tarjetas__dato small {
  color: #5f6368;
}
.saldos-tarjetas__codigo {
  font-family: "Courier New", monospace;
  letter-spacing: 1px;
}
@media (max-width: 600px) {
  .saldos-tarjetas__dato--principal {
    grid-column: auto;
  }
}
</style>
